export default __webpack_public_path__ + "static/media/Bolo-De-Coco-2.25677582.jpg";